<template>
  <main class="argentina">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/argentina/menu.vue';
import hero from '@/components/argentina/hero.vue';
import agenda from '@/components/argentina/agenda.vue';
import sponsors from '@/components/argentina/sponsors.vue';
import speakers from '@/components/argentina/speakers.vue';
import presenters from '@/components/argentina/presenters.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    speakers
  },
};
</script>

<style lang="scss" scoped>
  .argentina {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>